module.exports = __webpack_public_path__ + "img/img_profile_default.9288cbf2.svg";